import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section className="bg-background-100/70 border-t border-background-200" id="faq">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-label">FAQ</p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于本站，常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你对内容的来源、收录标准或投稿方式有疑问，这里整理了最常被问到的几个问题。
            </p>
            <p className="mt-5 text-sm text-foreground-600">
              还有其他疑问？欢迎前往
              <Link to="/about#contact" className="text-primary-600 hover:underline underline-offset-4 mx-1">
                联系与投稿
              </Link>
              页面留下你的想法。
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 border-t border-b border-background-200">
              {faqs.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(index)}
                        aria-expanded={open}
                        className="w-full flex items-start justify-between gap-4 py-5 text-left cursor-pointer group"
                      >
                        <span className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                          {item.q}
                        </span>
                        <span
                          className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                            open
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-700'
                          }`}
                        >
                          <i
                            className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-base leading-none`}
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </h3>
                    {open && (
                      <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}